import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import logo from "@/assets/logo.webp";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: "/", label: "Home" },
    { path: "/gallery", label: "Gallery" },
    { path: "/reviews", label: "Reviews" },
    { path: "/about", label: "About" },
    { path: "/contact", label: "Contact" },
  ];

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-primary/95 backdrop-blur-sm shadow-lg">
      <div className="container mx-auto px-4">
        {/* Mobile Layout - Logo Centered */}
        <div className="lg:hidden flex flex-col items-center pt-6 pb-3">
          {/* Mobile Menu Button - Top Right */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="absolute right-4 top-6 text-primary-foreground p-2"
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
          
          {/* Centered Logo on Mobile */}
          <Link to="/" className="flex items-center justify-center">
            <img 
              src={logo} 
              alt="Big Bear's Pro Floors" 
              className="h-24 w-auto"
              width={96}
              height={96}
              fetchPriority="high"
              loading="eager"
              decoding="async"
            />
          </Link>
        </div>

        {/* Desktop Layout */}
        <div className="hidden lg:flex items-center justify-between h-24">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img 
              src={logo} 
              alt="Big Bear's Pro Floors" 
              className="h-[7.8rem] w-auto"
              width={125}
              height={125}
              fetchPriority="high"
              loading="eager"
              decoding="async"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-primary-foreground font-heading font-medium uppercase tracking-wide text-sm hover:text-accent transition-colors duration-200 ${isActive(link.path) ? "text-accent border-b-2 border-accent" : ""}`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* CTA Button - Desktop */}
          <a
            href="tel:+17192327424"
            className="flex items-center gap-2 btn-cta-primary text-sm"
          >
            <Phone size={18} />
            Call Now
          </a>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="lg:hidden pb-6 border-t border-primary-foreground/20 pt-4">
            <div className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setIsMenuOpen(false)}
                  className={`text-primary-foreground font-heading font-medium uppercase tracking-wide text-sm hover:text-accent transition-colors duration-200 py-2 ${isActive(link.path) ? "text-accent border-b-2 border-accent" : ""}`}
                >
                  {link.label}
                </Link>
              ))}
              <a
                href="tel:+17192327424"
                className="btn-cta-primary text-center mt-4"
              >
                <Phone size={18} className="inline mr-2" />
                Call Now
              </a>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
